/** ----------------------------------------
    Has Value
 ---------------------------------------- */

const value = (value) => value != null ? value : '';

/** ----------------------------------------
    Dropdown Option
 ---------------------------------------- */

function listContainer(obj, items) {
    let html = `
        <section class="list">
            <div class="list__container--massive">
        
                <div class="section__row section__row--bottom">
                    <div class="section__title">${ value(obj.human_day) }</div>
                    <div class="section__sub">${ value(obj.human_date) }</div>
                </div>
        
                ${ items.map(item => item).join('') }
        
            </div>
        </section>
    `;

    return html;
}

function listItem(obj, parent) {
    let html = `
        <div class="list__row hide-mobile list-program ${obj.sold_out ? 'sold-out' : ''} list-item list-item--${value(obj.location_color)}">
            <a class="list-item--tiny list-item__time" href="${obj.selected_time_url}">${value(obj.starts_at)}</a>
            <a class="list-item--large list-item--wrapper" href="${obj.selected_time_url}">
                <div class="list-item--large list-item__title">
                    ${value(obj.title)}
                    ${note(obj)}
                </div>
            </a>
            <a class="list-item--small list-item__location" href="${obj.selected_time_url}">${value(obj.location_name)}</a>
            <a class="list-item--small list-item__type" href="${obj.selected_time_url}">${value(obj.genre)}</a>
            <a class="list-item--medium list-item__cta" href="${value(obj.url)}" target="_blank">
                ${availableTicket(obj)}
            </a>
        </div>

        <a class="list-program list__row mobile ${obj.sold_out ? 'sold-out' : ''} list-item list-item--${value(obj.location_color)}" href="${obj.selected_time_url}">
            <div class="list-item-wrapper">
                <div class="list-item--small list-item__time">${value(obj.starts_at)}</div>
                <div class="list-item--small list-item__location">${value(obj.location_name)}</div>
                <div class="list-item--small list-item__type">${value(obj.genre)}</div>
                <div class="list-item--small list-item__tickets ml-auto"> ${value(obj.button_text)}</div>
            </div>
            <div class="list-item--large list-item__title">${value(obj.title)}</div>
            ${note(obj)}
        </a>
    `;

    return html;
};

function availableTicket(obj) {
    return obj.sold_out ? ` <span class="btn-disabled--dark-grey">${value(obj.button_text)}</span>`
        : `<span class="btn-solid--orange list-item__button">${value(obj.button_text)}</span>`;
}

function note(obj) {
    return obj.note ? `<p class="list-item--wide list-item__note">${value(obj.note)}</p>`
        : '';
}

/** ----------------------------------------
    Export Templates
 ---------------------------------------- */

export {
    listContainer,
    listItem
}